import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { GuestKpiSnapshot, MarketingAlert, MarketingCampaign } from './marketing-dashboard.models';

@Injectable({
	providedIn: 'root'
})
export class MarketingDashboardService {

	constructor(private http: HttpClient) { }

	getGuestSnapshot(): Observable<GuestKpiSnapshot> {
		return this.http.get<GuestKpiSnapshot>(`${environment.apiUrl}/marketing/dashboard/guest-snapshot`);
	}

	getAlerts(): Observable<MarketingAlert[]> {
		return this.http.get<MarketingAlert[]>(`${environment.apiUrl}/marketing/dashboard/alerts`);
	}

	getCampaigns(): Observable<MarketingCampaign[]> {
		return this.http.get<MarketingCampaign[]>(`${environment.apiUrl}/marketing/dashboard/campaigns`);
	}
}
